<template>
  <div>
    <div class="question-container">
      <div class="question">
        <div class="number">Цитата {{(question.id + 1)}} из 10</div>

        <span v-html="question.text1"></span>
        <EmojiChecker
            v-bind:variants="arraysShuffle(question.variants[0])"
            v-bind:answered="answered"
            v-bind:correct="answer[0] == question.answer[0]"
            @update="setAnswer(0, ...arguments)"
        ></EmojiChecker>
        <span v-html="question.text1_2"></span>
        <EmojiChecker
            v-bind:variants="arraysShuffle(question.variants[1])"
            @update="setAnswer(1, ...arguments)"
            v-bind:answered="answered"
            v-bind:correct="answer[1] == question.answer[1]"

        ></EmojiChecker>
        <span v-html="question.text2_3"></span>

        <EmojiChecker
            v-bind:variants="arraysShuffle(question.variants[2])"
            v-bind:answered="answered"
            @update="setAnswer(2, ...arguments)"
            v-bind:correct="answer[2] == question.answer[2]"
        ></EmojiChecker>
        <span v-html="question.text3"></span>

      </div>
      <div class="sub-text">
        {{question.subText}}
      </div>
    </div>
    <div class="button-container">
      <button class="button" @click="buttonAction" v-html="buttonText" :class="buttonClass">

      </button>
    </div>
  </div>
</template>

<script>
import EmojiChecker from "./EmojiChecker";

export default {
  name: "Question",
  props: ["question"],
  data() {
    return {
      answer: [],
      correct: false,
      answered: false,
      defaultText: "готово!",
      wrongText: "вы немного ошиблись. <br>продолжить",
      correctText: "правильный ответ!<br>продолжить",
      first: true
    };
  },
  computed: {
    buttonText() {
      if (this.first) {
        return "выберите  подходящие эмодзи";
      }
      if (this.answered) {
        return this.correct ? this.correctText : this.wrongText;
      } else {
        return this.defaultText;
      }
    },
    buttonClass() {
      if (this.first) {
        return "first";
      }
      if (this.answered) {
        return this.correct ? "correct" : "wrong";
      } else {
        return "default";
      }
    }
  },
  components: {
    EmojiChecker
  },
  watch: {
    answer() {
    }
  },
  methods: {
    setAnswer(key, answer, first) {
      this.answer[key] = answer;
      if (!first) {
        this.first = false;
      }
    },

    buttonAction() {
      if (this.first) {
        return false;
      }
      if (this.answered === false) {
        this.answered = true;
        this.correct = this.arraysEqual(this.answer, this.question.answer);
      } else {
        this.$emit("next", this.correct);
        this.answered = false;
      }
    },
    arraysEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length != b.length) return false;
      for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    },
    arraysShuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    }
  }
};
</script>

<style scoped lang="scss">
.number {
  color: #b7b6b6;
  font-size: 18px; /* Приближение из-за подстановки шрифтов */
  font-weight: 400;
  line-height: 30px; /* Приближение из-за подстановки шрифтов */
  text-align: left;
}

.question {
  color: #03050c;
  font-size: 29px; /* Приближение из-за подстановки шрифтов */
  font-weight: 400;
  line-height: 48px; /* Приближение из-за подстановки шрифтов */
  text-align: left;
  padding-left: 40px;
  padding-right: 30px;
}
.question-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 420px;
}

.sub-text {
  font-family: Lava Pro Reg;
  color: #b7b6b6;
  font-size: 18px; /* Приближение из-за подстановки шрифтов */
  line-height: 30px; /* Приближение из-за подстановки шрифтов */
  text-align: left;
  font-style: italic;
  line-height: 40px;
  padding-left: 40px;
}

.button-container {
  button {
    width: 100%;
    height: 60px;
    text-align: center;
    align-items: center;
    border: 0;
    color: #ffffff;
    font-size: 13px;
    text-transform: uppercase;
    cursor: pointer;
    outline: 0;
    transition: background-color ease-in-out 100ms;
    &:focus {
      outline: 0;
    }
    &.default {
      background-color: #0047ff;
    }
    &.first {
      background-color: #a7a7a7;
    }
    &.correct {
      background-color: #39b54a;
    }
    &.wrong {
      background-color: #ff4950;
    }
  }
}
@media screen and (max-width: 480px) {
  .question{
    padding: 5px;
    line-height: 30px;
    font-size: 17px;
  }
  .sub-text{
    padding-left: 5px;
    font-size: 15px;
    line-height: 20px;
  }

}
</style>
